var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgResolutionDocumentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.1,
  width: 36,
  height: 36,
  rx: 2,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M25.577 8.23H16.27a.423.423 0 0 0-.423.424v4.653h-4.653a.423.423 0 0 0-.423.423v14.385c0 .234.189.423.423.423h14.384c.234 0 .423-.19.423-.423V8.654a.423.423 0 0 0-.423-.424Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.432 8.263a.423.423 0 0 0-.461.091l-5.077 5.077a.423.423 0 0 0 .3.723h5.076c.234 0 .423-.19.423-.423V8.654a.423.423 0 0 0-.261-.391Z",
  fill: "#00BAC6"
})));
export { SvgResolutionDocumentIcon as ReactComponent };
export default __webpack_public_path__ + "71b165f80b127f5e095aec0066dbc02b.svg";